import React from 'react';
import { AssignmentCard } from '../../components/assignmentCard';
import { SmallRoundedIconButton } from '../../components/Buttons';
import WhiteLabel from '../../filters/WhiteLabel';
import { PeopleAssignment } from './models/assignment';

type PersonAssignmentCardProps = {
  user: { isPending?: boolean };
  assignment: PeopleAssignment;
  unassignTraining: (assignment: PeopleAssignment) => void;
};

export default function PersonAssignmentCard({ user, assignment, unassignTraining }: PersonAssignmentCardProps) {
  const assignmentType = assignment._type;
  const isWorkflow = assignmentType === 'workflow';

  const progresses = user.isPending
    ? []
    : assignmentType === 'course'
    ? [assignment.progress]
    : assignment.assignable.tasklists?.map(tl => tl.progress) ?? [];

  const hasSteps =
    (assignment.progress && assignment.progress.steps) || (assignment.assignable && assignment.assignable.tasklists);
  const stepsTotal = hasSteps
    ? assignmentType === 'course'
      ? progresses[0]?.steps?.total
      : progresses.length
    : undefined;
  const stepsCompleted = hasSteps
    ? assignmentType === 'course'
      ? progresses[0]?.steps?.completed
      : progresses.filter(p => p._type === 'Finished').length
    : undefined;
  const stepLabel = assignmentType === 'course' ? WhiteLabel.labels.step : WhiteLabel.labels.course;

  return (
    <AssignmentCard>
      <AssignmentCard.Body>
        <AssignmentCard.Poster fallbackName={assignment.trainingName} />
        <AssignmentCard.Content>
          <AssignmentCard.Title
            name={assignment.trainingName}
            href={user.isPending ? undefined : `#/manage-assignments/${assignment._id}`}
            data-qa-hook="assignedTaskListPanelName"
          />

          <AssignmentCard.Details
            assignor={assignment.assignor}
            selfAssigned={assignment.assignable?.selfAssigned}
            shared={assignment.shared}
            sharedOn={assignment.sharedOn}
            assignedOn={assignment.assignedOn}
          />

          <AssignmentCard.Metadata
            type={isWorkflow ? 'pathway' : 'course'}
            stepsCompleted={stepsCompleted}
            stepsTotal={stepsTotal}
            stepLabel={stepLabel}
            completedOn={assignment.completedOn}
            dueDate={assignment.dueDate}
            pending={user.isPending}
          />

          <AssignmentCard.Progress
            variant={isWorkflow ? 'pathway' : 'course'}
            segments={progresses.map(p => p.percent)}
          />
        </AssignmentCard.Content>
        <AssignmentCard.Actions>
          <SmallRoundedIconButton data-qa-hook="assignmentRemoveTraining" onClick={() => unassignTraining(assignment)}>
            <i className="far fa-trash-alt" />
          </SmallRoundedIconButton>
        </AssignmentCard.Actions>
      </AssignmentCard.Body>
    </AssignmentCard>
  );
}
